import React, { useState } from "react";
import { Button, SmallLoader } from "../../components";
import appConfig from "../../util/appConfig";
import API from "../../api/api";
import { useAppSelector } from "../../store";

const Lra = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { eigentuemerwechselItem } = useAppSelector(
    (state) => state.eigentuemerwechsel.admin,
  );
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "flex-end",
      }}
    >
      <Button
        text={
          !isLoading ? "Dokument laden" : <SmallLoader loaderDotSize="10" />
        }
        width="200"
        isOutlined
        outlineColor={appConfig.mainColor}
        textColor={appConfig.mainColor}
        onClick={async () => {
          if (isLoading) {
            return;
          }
          if (!eigentuemerwechselItem) {
            return;
          }
          setIsLoading(true);

          await API.eigentuemerwechsel.get
            .geEigentuemerwechselDoc(eigentuemerwechselItem.id)
            .finally(() => {
              setIsLoading(false);
            });
        }}
      />
    </div>
  );
};

export default Lra;
